import React, { FC } from 'react';
import logoFile from 'assets/img/logo/logo-text-white.png';

interface ILogoProps {
	width?: number;
	height?: number;
}
const LogoLight: FC<ILogoProps> = ({ width = 2155, height = 854 }) => {
	return (
		<img
			width={height !== 854 ? height * (2155 / 854) : width}
			height={width !== 2155 ? width * (854 / 2155) : height}
			style={{ objectFit: 'contain' }}
			src={logoFile}
			alt='WhiteCrust'
		/>
	);
};

export default LogoLight;
